<template>
  <v-app id="inspire" class="c-bg-gray">
    <v-main class="tw-w-full">
      <v-container class="fill-height" fluid>
        <v-col cols="12" class="col-md-10 offset-md-1 col-sm-12 tw-mt-5 md:tw-mt-0">
          <v-row align="center" justify="center">

            <v-col id="confirm" cols="12" md="5">
              <v-card class="pa-4 elevation-3">
                <div class="tw-w-full tw-flex tw-justify-center">
                  <img src="/logo.svg" class="tw-w-24 md:tw-w-32 tw-mt-4 md:tw-mt-6" alt="logo">
                </div>
                <v-card-text class="tw-px-4 md:tw-px-10" >
                  <div class="tw-w-full tw-text-center tw-mt-6">
                    <h2 class="c-blue-text title">Kindly enter the 6 digit OTP</h2>
                    <p class="tw-mt-2 tw-pb-4">Please check your phone/email for the OTP sent </p>
                  </div>
                  <v-form ref="form">
                    <label for="otp-input" class="tw-font-bold tw-ml-6">One Time Password</label>
                    <vie-otp-input
                      id="otp-input"
                      v-model="token"
                      :class="['otp-input tw-mt-3', error === null ? 'otp-input-normal' : 'otp-input-error']"
                      :size="24"
                      :length="6"
                      @change="otpValidation"
                    />
                    <p v-if="error !== null" class="tw-text-red-600 tw-mt-3 tw-text-xs tw-ml-6">{{ error }}</p>
                  </v-form>

                </v-card-text>

                <v-card-actions class="tw-w-full tw-flex justify-center">
                  <a id="otp-resend" class="tw-font-bold" href="#" @click.prevent="confirmResend">{{ resend }}</a>
                </v-card-actions>

                <v-card-actions class="col-sm-6 offset-sm-3">
                  <v-btn block large
                         id="otp-send"
                         color="secondary"
                         @click="confirmOtp"
                         :loading="loading"
                         :disabled="!isValid">
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <div class="tw-w-full tw-grid tw-grid-cols-2 tw-absolute tw-left-0 tw-bottom-0">
              <div class="c-bg-blue tw-py-1"></div>
              <div class="c-bg-red tw-py-1"></div>
            </div>

          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import VieOtpInput from '@8bu/vue-otp-input';
import { mapGetters } from 'vuex';
import { CR_KEY, FB_OTP, USER_OTP } from '@/utils/const';

export default {
  name: 'ConfirmLoginOTP',
  metaInfo: {
    title: 'Confirm Login OTP',
  },
  data() {
    return {
      token: '',
      error: null,
      isValid: false,
      loading: false,
      resend: 'Resend OTP',
      query: '',
    };
  },
  components: {
    VieOtpInput,
  },
  computed: {
    ...mapGetters('auth', ['hasAuthenticationStatus', 'authenticationStatus']),
  },
  mounted() {
    this.$store.dispatch('auth/clearAuthenticationStatus');
    const quote = this.$route.query.q;
    const benefit = this.$route.query.b;
    if (!!quote && !!benefit) {
      this.query = this.$route.query;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$cookies.get(USER_OTP)) {
        vm.$router.push({ name: 'SignUp' });
      }
    });
  },
  methods: {
    async confirmOtp() {
      this.loading = true;

      await this.$store.dispatch('auth/validateLoginOtp', this.token);

      if (this.hasAuthenticationStatus) {
        this.loading = false;

        const { variant, message } = this.authenticationStatus;
        if (variant === 'error') {
          this.$toast.error(message, 'Error');
        } else {
          this.$toast.success(message, 'Success');

          const key = this.$cookies.get(CR_KEY);

          if (key !== null) {
            const creds = this.CryptoJS.AES.decrypt(key, CR_KEY).toString(this.CryptoJS.enc.Utf8);

            await this.$store.dispatch('auth/signIn', JSON.parse(creds));

            this.$cookies.remove(CR_KEY);
            this.token = '';
            this.loading = false;
            this.$analytics.logEvent(FB_OTP);

            if (variant === 'error') {
              this.$router.push({ name: 'SignIn', query: this.query });
            } else if (this.query !== '') {
              this.$router.push({ name: 'BuyCover', query: this.query });
            } else {
              this.$router.push({ name: 'Dashboard' });
            }
          } else {
            this.$router.push({ name: 'SignIn', query: this.query });
          }
        }
      }
    },
    async confirmResend() {
      this.resend = 'Resending OTP...';
      this.token = '';
      await this.$store.dispatch('auth/regenerateOtp').then(() => {
        if (this.hasAuthenticationStatus) {
          if (this.authenticationStatus.variant === 'error') {
            this.$toast.error(this.authenticationStatus.message, 'Error');
          } else {
            this.$toast.success(this.authenticationStatus.message, 'Success');
          }
        }
        this.resend = 'Resend OTP';
      });
    },
    otpValidation() {
      if (this.token === '' || this.token.toString().length !== 6) {
        this.error = 'Enter 6 digit OTP';
        this.isValid = false;
        this.loading = false;
        return false;
      }
      this.error = null;
      this.isValid = true;
      return true;
    },
  },
};
</script>

<style lang="scss">
  .otp-input-error {
    .otp-input-8-field {
      &::after {
        background-color: red;
      }
    }
  }
  .otp-input-normal {
    .otp-input-8-field {
      &::after {
        background-color: var(--light-gray-color);
      }
    }
  }
  .otp-input {
    display: flex;
    .otp-input-8-field {
      position: relative;
      width: 20%;
    &::after {
       content: '';
       border-radius: 9999px;
       bottom: 0;
       left: 0;
       right: 0;
       position: absolute;
       display: block;
       height: 3px;
     }
    &:not(:last-child) {
       margin-right: 0.5rem;
     }
    input {
      background: transparent;
      color: var(--gray-color);
      font-weight: bold;
      width: 100%;
      border: none;
      text-align: center;
      &:focus{
        outline: none;
      }
    }
    }
  }
</style>
